import { Contract } from "appworks/utils/contracts/contract";
import { ThemeAnimateSymbolBehaviour } from "behaviours/theme-animate-symbol-behaviour";

/**
 * ThemeAnimateIterativeBehaviour is a class that extends AnimateSymbolBehaviour.
 * It is responsible for managing and controlling the animation of symbols in different states. Specifically, this class makes use of the
 * 'chain' parameter in order to play animations a finite number of times.
 */
export class ThemeFiniteAnimationBehaviour extends ThemeAnimateSymbolBehaviour {

    /**
     * This method is responsible for the highlight animation. This specific override of cycle makes use of the chain parameter of the animate method inside of
     * theme-animate-symbol-behaviour.ts
     * @returns {Contract<void>} - An empty promise represented as a Contract.
     */
    public override highlight(): Contract<void> {
        return Contract.empty();
    }

    /**
     * This method is responsible for the cycle animation. This specific override of cycle makes use of the chain parameter of the animate method inside of
     * theme-animate-symbol-behaviour.ts
     * @returns {Contract<void>} - This returns the animation contract that animates the given symbol animation (symbolname_win) on top of the
     *                             static symbol supplied by the base-animate-symbol-behaviour.ts module.
     */
    public override cycle(): Contract<void> {
        return this.animate(["_highlight", "_win"], [this.defaultAnimation], false);
    }
}